export const CheckCircleIcon = ({ className }) => {
  return (
    <svg className={className} width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="check-circle">
    <path id="Vector" d="M88 44.3195V47.9995C87.9951 56.6251 85.202 65.0182 80.0373 71.9268C74.8727 78.8354 67.6131 83.8894 59.3414 86.3351C51.0697 88.7807 42.229 88.4871 34.1379 85.4978C26.0467 82.5085 19.1386 76.9839 14.4438 69.7477C9.74907 62.5116 7.51916 53.9517 8.08671 45.3447C8.65425 36.7377 11.9888 28.5448 17.5931 21.9877C23.1974 15.4307 30.7711 10.861 39.1848 8.96004C47.5984 7.0591 56.4011 7.92881 64.28 11.4395" stroke="#2AB95E" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round"/>
    <path id="Vector_2" d="M88 16L48 56.04L36 44.04" stroke="#2AB95E" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    </svg>
  )
}